<template>
  <div>
    <label for="optionRange"><slot>Required Selection Number</slot></label>
    <multi-input compress>
      <column>
        <a-select
          id="optionRange"
          v-model="optionRangeType"
          :options="checkboxRangeOptions"
          :disabled="disabled"
        ></a-select>
      </column>
      <column v-if="showCheckboxMin">
        <number-input
          id="checkbox_range_min"
          v-model="model.checkbox_range_min"
          :min="min"
          :max="model.checkbox_range_max"
          :placeholder="minPlaceholder"
          :disabled="disabled"
          :key="`${model.client_id}_min`"
        ></number-input>
      </column>
      <column v-if="showCheckboxMax">
        <number-input
          id="checkboxRangeMax"
          v-model="model.checkbox_range_max"
          @blur="maxChanged()"
          :min="model.checkbox_range_min"
          :max="max"
          placeholder="Max"
          :disabled="disabled"
          :key="`${model.client_id}_max`"
        ></number-input>
      </column>
    </multi-input>
  </div>
</template>


<script lang="ts">
  import Vue from "vue";
  import {OptionRangeType} from "~/enums/optionRangeType";
  import toFixed from "../../../../../../common/helpers/toFixed";
  import {IOptionRangeRequirable} from "../../../../../../common/interfaces/propertyInterfaces";

  export default Vue.extend({
    mixins: [],
    props: {
      model: {
        type: Object as () => IOptionRangeRequirable,
      },
      disabled: Boolean,
      min: {
        type: Number,
        default: 1,
      },
      max: {
        type: Number,
        default: null,
      },
    },
    data: function () {
      return {
        OptionRangeType: OptionRangeType
      };
    },
    computed: {
      minPlaceholder() {
        return this.optionRangeType === OptionRangeType.Exactly ? '' : 'Min';
      },
      showCheckboxMin() {
        return [OptionRangeType.AtLeast, OptionRangeType.Exactly, OptionRangeType.Between].includes(this.model.option_range_type);
      },
      showCheckboxMax() {
        return [OptionRangeType.AtMost, OptionRangeType.Between].includes(this.model.option_range_type);
      },
      optionRangeType: {
        get(): any {
          return this.model.option_range_type;
        },
        set(value: any) {
          this.model.option_range_type = value;
          this.model.checkbox_range_max = null;
          this.model.checkbox_range_min = 1;
        }
      },
      checkboxRangeOptions() {
        return [
          {label: 'At Least', value: OptionRangeType.AtLeast},
          {label: 'At Most', value: OptionRangeType.AtMost},
          {label: 'Exactly', value: OptionRangeType.Exactly},
          {label: 'Between', value: OptionRangeType.Between},
          {label: 'All', value: OptionRangeType.All}
        ]
      }
    },
    methods: {
      minChanged() {
        this.model.checkbox_range_min = Number(toFixed(this.model.checkbox_range_min, 0));
        if (this.model.checkbox_range_min <= 0) {
          this.model.checkbox_range_min = 1;
        }
      },
      maxChanged() {
        if (this.model.checkbox_range_max) {
          this.model.checkbox_range_max = Number(toFixed(this.model.checkbox_range_max, 0));
          if (this.model.checkbox_range_max <= 0) {
            this.model.checkbox_range_max = 1;
          }
        }
      }
    },
  });
</script>

